/* global IntersectionObserver */
import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
import {
    AutoScroll,
} from '@splidejs/splide-extension-auto-scroll';

// swiperInit.js
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.image-carousel-stats-section');
    if (!sections.length) {return;}

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const section = entry.target;
                const icssSlider = section.querySelector('.icss-carsousel');
                const icssStatSlider = section.querySelectorAll('.icss-stats-carousel');

                if (icssSlider) {
                    const icssInstance = new Splide(icssSlider, {
                        type: 'loop',
                        gap: 45,
                        drag: false,
                        arrows: false,
                        pagination: false,
                        autoWidth: true,
                        autoScroll: {
                            speed: 0.4,
                            pauseOnHover: false,
                        },
                    });

                    // Mount with AutoScroll extension
                    icssInstance.mount({
                        AutoScroll,
                    });
                }

                if (icssStatSlider.length) {
                    icssStatSlider.forEach(slider => {
                        new Swiper(slider, {
                            loop: false,
                            slidesPerView: 'auto',
                            spaceBetween: 20,
                            navigation: {
                                prevEl: slider.querySelector('.icss-button-prev'),
                                nextEl: slider.querySelector('.icss-button-next'),
                            },
                            breakpoints: {
                                576: {
                                    slidesPerView: 3,
                                },
                                768: {
                                    slidesPerView: 4,
                                },
                                992: {
                                    slidesPerView: 5,
                                },
                                1200: {
                                    slidesPerView: 6,
                                },
                            },
                        });
                    });
                }
                obs.unobserve(section);
            }
        });
    }, { rootMargin: '150px' });

    sections.forEach(section => observer.observe(section));
});